import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
interface Crumb {
  name: string;
  path?: string;
}
interface PageHeroProps {
  eyebrow: string;
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  crumbs: Crumb[];
}
export function PageHero({
  eyebrow,
  title,
  description,
  image,
  imageAlt,
  crumbs
}: PageHeroProps) {
  return <section className="relative isolate overflow-hidden bg-navy" data-id="element-147" data-mp="psjuad10x88w">
      <img src={image} alt={imageAlt} className="absolute inset-0 h-full w-full object-cover" data-id="element-148" data-mp="pv6at25w6y39" />
      <div className="absolute inset-0 bg-navy/80" aria-hidden="true" data-id="element-149" data-mp="uu95bso8xlwz" />
      <div className="relative mx-auto max-w-page px-4 py-16 sm:px-6 md:py-20 lg:px-8" data-id="element-150" data-mp="g2iee8itqw52">
        <nav aria-label="Breadcrumb" data-id="element-151" data-mp="l1bn7nn61yyw">
          <ol className="flex flex-wrap items-center gap-1.5 text-sm text-white/70" data-id="element-152" data-mp="l0abdgybt8g4">
            {crumbs.map((crumb, index) => <li key={crumb.name} className="flex items-center gap-1.5" data-id="element-153" data-mp="1dj7he5jig4g1" data-mpi={index}>
                {index > 0 && <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-154" data-mp="32i2dmjgf07k4" />}
                {crumb.path ? <Link to={crumb.path} className="hover:text-white" data-id="element-155" data-mp="2xjr2m5edvr0b">
                    {crumb.name}
                  </Link> : <span className="font-semibold text-white" aria-current="page" data-id="element-156" data-mp="3c9gb6lot2xam">
                    {crumb.name}
                  </span>}
              </li>)}
          </ol>
        </nav>
        <p className="mt-8 text-sm font-bold uppercase tracking-wider text-cta-light" data-id="element-157" data-mp="3lamu11exgk71">{eyebrow}</p>
        <h1 className="mt-3 max-w-3xl font-display text-3xl font-extrabold leading-tight tracking-tight text-white md:text-5xl" data-id="element-158" data-mp="3gc32mlhkeg7a">
          {title}
        </h1>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-white/85" data-id="element-159" data-mp="3q97sowej6vtd">{description}</p>
      </div>
    </section>;
}